export class InboundServer {
    id: number;
    server_host: string;
}
